module.exports = __webpack_public_path__ + "static/media/400017_02.41e2337b.png";